<dx-popup title="Job" [width]="300" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="dumpsterInventory" validationGroup="mainValidationGroup" style="min-height: 125px">
        <dxi-form-item
            dataField="dumpsterTypeId"
            [label]="{ text: 'Dumpster Type' }"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: dumpsterTypes, displayExpr: 'size', valueExpr: 'id' }"
        >
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
            <dxi-form-validation-rule type="range" [min]="1" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="dumpsterNumber" editorType="dxNumberBox">
            <dxi-form-validation-rule
                type="custom"
                [validationCallback]="isNumberUnique"
                message="Dumpster Number Already Used"
                [reevaluate]="true"
            >
            </dxi-form-validation-rule>
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
    </dx-form>
</dx-popup>
